import { handleActions } from 'redux-actions'
import { CompanyStatistics } from '../../../services/api.types'
import { getSpecificCompanyStatisticsSuccess } from './StatisticsActions'

class State {
  companyStatistics: CompanyStatistics = {
    companyEnergyStatistics: { bigMacs: 0.0, totalKcal: 0.0 },
    companyIntensiveMinutesStatistics: { co2EmissionPrevented: 0.0, totalMin: 0.0 },
    companyStepsStatistics: { totalSteps: 0.0, roundsAroundTheWorld: 0.0, totalDistance: 0.0 },
  }
}

export const statistics = handleActions<State, any>(
  {
    [String(getSpecificCompanyStatisticsSuccess)]: (state: State, { payload }: any): State => ({
      ...state,
      companyStatistics: payload,
    }),
  },
  new State(),
)

export { State as StatisticsState }
